var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Heading",attrs:{"id":_vm.BlocksIndex}},[_c('BaseTextBlock',{attrs:{"value":_vm.value,"BlocksIndex":_vm.BlocksIndex,"customStyle":_vm.customStyle,"placeholder":_vm.placeholder}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }